import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Content from "./content";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * WalletCardManagement
 *
 * کامپوننت مدیریت کارت‌های شتابی پذیرنده.
 *
 * این کامپوننت بخش مدیریت کارت‌های شتابی را نمایش می‌دهد و شامل:
 * - عنوان بخش با آیکون کیف پول
 * - نمایش محتوای مربوط به کارت‌ها از طریق کامپوننت `Content`
 *
 * ویژگی‌ها:
 * - استفاده از `StackKit` برای چینش ریسپانسیو (ستون در صفحه کوچک و ردیف در صفحه بزرگ)
 * - نمایش آیکون و عنوان بخش به صورت افقی
 *
 * @returns JSX.Element
 */

const WalletCardManagement = () => {
 
  return (
    <StackKit direction={{ md: "column", lg: "row" }} justifyContent={{ md: "start", lg: "space-between" }} alignItems={"center"}>
      <StackKit sx={{width:"100%"}}>
        <StackKit direction={"row"} justifyContent={"start"} alignItems={"center"}>
          <AccountBalanceWalletOutlinedIcon />
          <TypoGraphyKit variant="h5">
            مدیریت کارت های شتابی
          </TypoGraphyKit>
        </StackKit>
        <Content/>
      </StackKit> 
    </StackKit>
  );
};

export default WalletCardManagement;
